<template>
  <div>
    <div v-for="i in count" :key="i">
      <vue-content-loading :width="400" :height="90" preserveAspectRatio="none">
        <rect x="0" y="20" rx="4" ry="4" width="90" height="60" />
        <rect x="110" y="30" rx="4" ry="4" width="200" height="20" />
        <rect x="110" y="60" rx="4" ry="4" width="200" height="10" />
      </vue-content-loading>
    </div>
  </div>
</template>

<script>
import { VueContentLoading } from "vue-content-loading";

export default {
  name: "news-feed-loading-skeleton",
  props: {
    count: {
      type: Number,
      default: 7,
    },
  },
  components: { VueContentLoading },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/NewsFeedLoadingSkeleton.vue